<template>
  <tr>
    <td class="middle text-right" colspan="3">
      <b>RAZEM:</b>
    </td>

    <td class="text-right middle">
      <w-input mock :model="model.plnSum">{{ formatAmount(model.plnSum.$getData()) }}</w-input>
    </td>

    <td class="text-right middle">
      <w-input mock :model="model.euroSum">{{ formatAmount(model.euroSum.$getData()) }}</w-input>
    </td>

    <td />
  </tr>
</template>

<script>
import components from '@witkac/bootstrap4-components';

import { formatAmount } from '@/filters/formatAmount';

// @vuese
// @De Minimis Sum
// @Group formStaticComponents
export default {
  components,
  props: {
    // Przekazana wartośc do wyświetlenia
    model: { type: Object, required: true }
  },
  methods: {
    formatAmount
  }
};
</script>
